<video autoplay muted loop class="tagline-video">
    <source src="../../../../../assets/video/mice.webm" type="video/webm">
 </video>